import Vue from 'vue'

// 展示两位小数
Vue.filter('float', (value, digits = 2) => {
  const floatValue = parseFloat(value).toFixed(digits)
  return isNaN(floatValue) ? value : floatValue
})
